import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import LocationHeader from '../containers/locations/LocationHeader';
import LocationList from '../containers/locations/LocationList';


export default function (children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <LocationHeader />
          <PageContentWrapper>
            <LocationList />
          </PageContentWrapper>
          {children}
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
};
